<h1>Select Accounts</h1>
<br>
<app-account-ownership></app-account-ownership>
<mat-divider class="red-divider"></mat-divider>
<app-account-selection></app-account-selection>
<mat-divider class="red-divider"></mat-divider>
<!-- app-promo-code></app-promo-code>
<mat-divider class="red-divider"></mat-divider-->
